export const productProfileQuery = `query getProductProfile ($productId: ID!, $viewerCompanyId: ID!) {
      productProfile  (id: $productId) {
        id
        name
        productId
        amenities
        bedsAndSofas {
          isApartment
          rooms {
            count
            bedType
            other
          }
        }
        checkIn
        checkOut
        description
        imageUrls
        isMarketingReady
        interconnectingRooms
        connectionInfo (viewerCompanyId: $viewerCompanyId) {
          status
          isSender
          lastSent
          id
          shouldShowContactInfo
        }
        locationName
        locationId
        productCode
        notes
        totalMaxPassengers
        totalMinPassengers
        productName
        companyId
        companyName
        profileImageUrl
        coverImageUrl
        tourDuration {
          value
          unit
        }
        tourDurationDoesNotApply
        roomCountInfo {
          value
          unit
        }
        roomSizeInfo {
          value
          unit
        }
        productInfo {
          include
          exclude
          whatToBring
        }
        roomSize
        productType
        type
      }
    }`;


// WEBPACK FOOTER //
// ./src/app/stores/company/product/product-graphql-query.js